import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-i/cultures/asciticFluidCulture";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	asciticFluidCulture: {
		id: "form.ascitic_fluid_culture",
		defaultMessage: "Ascitestenyésztés"
	},
	result: {
		id: "form.ascitic_fluid_culture.result",
		defaultMessage: "Eltérés"
	},
	comment: {
		id: "form.ascitic_fluid_culture.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	},
	comment: {
		type: "field",
		path: ["resultComment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "asciticFluidCulture",
	value: {
		title: messages.asciticFluidCulture,
		validator,
		fieldset,
		isImportant: true
	}
};
